import generateDepartureRoomPriceBreakdown from './generateDepartureRoomPriceBreakdown'

export default function generateDepartureRoomDisplayPriceBreakdown(
  occupants: App.Occupants,
  option: App.Tours.TourV2OfferPurchasableOption,
  offer?: App.Tours.TourV2Offer,
): App.Tours.V2OfferDeparturePriceBreakdown {
  const breakdown = generateDepartureRoomPriceBreakdown(occupants, option, offer)
  const bundledPrice = option.bundledPrice
  if (offer?.source === 'ttc' || !option.ltleBundleId || bundledPrice === undefined) return breakdown
  const bundleMemberPrice = option.bundleMemberPrice
  const childTotal = breakdown.childrenPriceBreakdown.reduce((total, price) => total + price, 0)

  return {
    ...breakdown,
    pricePerAdult: bundledPrice,
    memberPricePerAdult: bundleMemberPrice ?? 0,
    adultsPriceBreakdown: breakdown.adultsPriceBreakdown.map(() => bundledPrice),
    adultsMemberPriceBreakdown: breakdown.adultsMemberPriceBreakdown.map(() => bundleMemberPrice ?? 0),
    totalPrice: breakdown.totalPrice + occupants.adults * (bundledPrice - option.price),
    totalMemberPrice: bundleMemberPrice === undefined ? 0 : occupants.adults * bundleMemberPrice + childTotal,
  }
}
